<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ privacySettingsTitle | translate }}
            </h1>
            <p class="subtitle-s">
                {{ privacySettingsSubtitle | translate }}
            </p>
        </div>


        <form class="toggle-list" [formGroup]="formGroup">
            <div class="first-toggle">
                <app-toogle-switch (onChange)="onChangePrivacy1($event)"></app-toogle-switch>
                <span class="text-description-first">{{ textCheckbox1 | translate }}</span>
            </div>

            <div class="n-toggle">
                <app-toogle-switch (onChange)="onChangePrivacy2($event)"></app-toogle-switch>
                <span class="text-description">
                    <expansion-overview-example [textoExpansion]="textCheckbox2"></expansion-overview-example>
                </span>
            </div>
            <div class="n-toggle">
                <app-toogle-switch (onChange)="onChangePrivacy3($event)"></app-toogle-switch>
                <span class="text-description">
                    <expansion-overview-example [textoExpansion]="textCheckbox3"></expansion-overview-example>
                </span>
            </div>
            <div class="n-toggle">
                <app-toogle-switch (onChange)="onChangePrivacy4($event)"></app-toogle-switch>
                <span class="text-description">
                    <expansion-overview-example [textoExpansion]="textCheckbox4"></expansion-overview-example>
                </span>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
